// extracted by mini-css-extract-plugin
export default {"AlertAppearanceParagraph":"NewNotification_AlertAppearanceParagraph__P7SUf"};